/**
 * @file Credits a charge through `charges/:id/credit` and confirms it in a snackbar.
 * A refusal the credit route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  be_ajv_not_validated: null,
  financial_operations_were_blocked: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-financial-processing-busy" },
  be_unauthorized: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-charge-not-found" },
  cannot_credit_direct_charge: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-direct-charge" },
  cannot_credit_charge_with_amount_zero: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-amount-zero" },
  credit_amount_is_larger_than_invoiced_amount: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-amount-too-large" },
  cannot_credit_credit_charge: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-of-credit" },
  cannot_credit_charges_with_system_types: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-system-charge" },
  cannot_credit_charges_which_was_settled_with_savings: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-savings" },
  credit_is_impossible: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-object-counterparty" },
  cannot_credit_payout_charge: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-payout" },
  cannot_credit_credited_charge: { titleKey: "refusal-title-credit", bodyKey: "refusal-body-credit-already-credited" }
};

export default function* chargeCredit(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_REQUEST
    });

    yield call(Http.post, `charges/${action.payload?.charge?.id}/credit`, {
      amount: action.payload?.amount,
      description: action.payload?.description,
      invoiceDate: action.payload?.invoiceDate,
      invoiceNumber: action.payload?.invoiceNumber
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-credited-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeCredit() {
  yield takeEvery(Constants.GLOBAL_CHARGE_CREATE_CREDIT_START, chargeCredit);
}
